import type { IconType } from "../..";
import useBreakpoints from "../../useBreakpoints";
import Box from "../Box";
import FeatureListItem from "../FeatureListItem/FeatureListItem";

export type FeatureProp = {
	icon: IconType;
	title: string;
	subtitle: string;
};

type Props = {
	valueProps: FeatureProp[];
};

const FeatureList = ({ valueProps }: Props) => {
	const { smUp } = useBreakpoints();

	return (
		<Box flexDirection={smUp ? "row" : "column"} gap={24}>
			{valueProps.map((prop, index) => (
				<FeatureListItem
					key={`${prop.title}-${index}`}
					icon={prop.icon}
					title={prop.title}
					subtitle={prop.subtitle}
				/>
			))}
		</Box>
	);
};

export default FeatureList;
